<template>

    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Receipts List</h4>
                <p class="subtitle-1">List of Goods Receipts</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row  align="center">
            
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false" >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            depressed
                            block
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        outlined
                                        dense
                                        hide-details="auto"
                                        label="Code"
                                        v-model="searchForm.code"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        outlined
                                        dense
                                        label="Supplier"
                                        hide-details="auto"
                                        @update:search-input="searchSuppliers"
                                        :items="suppliers"
                                        item-value="id"
                                        item-text="name"
                                        v-model="searchForm.supplier_id"
                                        clearable
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn  color="primary" block @click="handleSubmit">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="items"
                    :options.sync="options"
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :loading="loading"
                >
                    <template v-slot:[`item.code`]="{item}">
                        <v-btn icon @click="handleClickRow(item)" >
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        {{item.code}}
                    </template>
                    <template v-slot:[`item.purchase_order_code`]="{item}">
                        <span class="text-decoration-underline font-weight-bold" @click="showPurchaseOrder(item)" style="cursor: pointer">
                            {{item.purchase_order_code}}
                        </span>
                    </template>
                    <template v-slot:[`item.state`]="{item}">
                        <PStatus :state="item.state"/>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PStatus from "./../../components/common/PStatus.vue"
import { mapActions, mapGetters } from 'vuex';
import goodReceiptAPI from './../../services/purchase/goodReceipt.js';


export default {
    components: {
        PStatus
    },
    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Supplier", value: "supplier" },
                { text: "Order Code", value: "purchase_order_code" },
                { text: "State", value: "state" },
            ],
            items: [],
            options: {},
            warehouse_id: null,
            page: 1,
            serverItemsLength: null,
            loading: false,
            searchForm: {
                code: "",
                supplier_id: ""
            }
            
        }
    },
    watch: {
        options: {
            deep: true,
        
            handler() {
                this.list()
            }
        }
    },
    computed: {
        ...mapGetters({
            suppliers: "purchase/supplier/list",
        })
    },
    methods: {
        ...mapActions({
            searchSuppliers: "purchase/supplier/search"
        }),
        list() {
            this.loading = true;
            goodReceiptAPI.index({...this.options, state: 1, warehouse_id: this.warehouse_id ,...this.searchForm}).then(res => {
                this.items = res.data.data
                this.serverItemsLength = res.data.count
            }).finally(() => {
                this.loading = false
            })
        },
        handleClickRow(item) {
            this.$router.push({name: "ReceiptDisplay", params: {id: item.id}})
        },
        handleSubmit() {
            this.list()
        },
        showPurchaseOrder(item) {
            this.$router.push({ name : 'Order', params: { id: item.id }})
        }
        
    },
    created() {
        this.warehouse_id = this.$route.params.warehouseId  
    }
}
</script>

<style>

</style>